import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import { GoogleApiWrapper, Map, Marker } from 'google-maps-react';
import { googleMapsService } from '../../_services'
import React, { useEffect, useState } from 'react';
import { TextValidator } from 'react-material-ui-form-validator';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { stringUtils } from '../../utils';
import { obraAction } from '../../_actions';
import CustomButton from '../CustomButton';
import AddLocationAltOutlinedIcon from '@mui/icons-material/AddLocationAltOutlined';
import SearchIcon from '@mui/icons-material/Search';
import MapContainerCoordenadasModal from '../../components/Maps/MapContainerCoordenadasModal'

const MapContainer = (props) => {

  const { classes, obra, obraCoordenada, isEditable } = props;

  const dispatch = useDispatch();

  const [endereco, setEndereco] = useState('');
  const [exibeBotaoPontosAdicionais, setExibeBotaoPontosAdicionais] = useState(false);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  useEffect(() => {
    //quando não houver localização setada, pega a do usuário 
    if (!props.latitude && !props.longitude) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            var changeLatUser = {
              type: 'select',
              target: {
                value: position.coords.latitude
              }
            };
            dispatch(obraAction.onChangeProps('latitude', changeLatUser))

            var changeLongUser = {
              type: 'select',
              target: {
                value: position.coords.longitude
              }
            };
            dispatch(obraAction.onChangeProps('longitude', changeLongUser))
          },
          error => {
            console.error('Error ao obter a localização do usuário:', error);
          }
        );
      } else {
        console.error('Geolocation não é suportada por esse navegador.');
      }
    } else
      if (props && props.latitude && props.longitude) {
        displayMarkers();
      }

  }, [])

  const handleOpenModalPontosAdicionais = () => {
    setExibeBotaoPontosAdicionais(false);
    toggle();
  }

  const getLatitudeLongitude = () => {

    if (endereco) {
      const geocoder = new props.google.maps.Geocoder();

      geocoder.geocode({ address: endereco }, (response) => {
        if (response?.length) {
          let changeLatEvent = {
            type: 'text',
            target: {
              value: response[0]?.geometry?.location?.lat()
            }
          };
          dispatch(obraAction.onChangeProps('latitude', changeLatEvent));

          let changeLngEvent = {
            type: 'text',
            target: {
              value: response[0]?.geometry?.location?.lng()
            }
          };
          dispatch(obraAction.onChangeProps('longitude', changeLngEvent));

          let changeEnderecoEvent = {
            type: 'text',
            target: {
              value: endereco
            }
          };
          dispatch(obraAction.onChangeProps('endereco', changeEnderecoEvent));

        } else if (response?.status === 'REQUEST_DENIED') {
          toast.error('Ocorreu um problema ao realizar a busca do endereço')
        } else {
          toast.error('O endereço informado não foi localizado')
        }
      });
    } else {
      toast.error('Digite um endereço')
    }
  }

  const handleMarkerDrag = (map) => {
    const geocoder = new props.google.maps.Geocoder();

    geocoder.geocode({ location: { lat: map.position.lat(), lng: map.position.lng() } }, (response) => {

      if (response?.length) {
        setEndereco(response[0].formatted_address.toUpperCase())
        let changeLatEvent = {
          type: 'text',
          target: {
            value: map.position.lat()
          }
        };
        dispatch(obraAction.onChangeProps('latitude', changeLatEvent));

        let changeLngEvent = {
          type: 'text',
          target: {
            value: map.position.lng()
          }
        };
        dispatch(obraAction.onChangeProps('longitude', changeLngEvent));
      } else {
        toast.error('Ocorreu um problema ao utliziar esta localização')
      }
    })

  };

  const displayMarkers = () => {
    return (
      <Marker
        key={'marker'}
        id={0}
        position={{ lat: props.latitude, lng: props.longitude }}
        icon={require('../../img/raiarR.png')}
        draggable={isEditable(obra.ultimoEvento) == false ? false : true}
        onDragend={(e, map) => handleMarkerDrag(map)}
        tracksViewChanges
      />
    );
  };

  return (
    <>
      <Grid item lg={12} md={12} xl={12} xs={12}>
        <Typography>
          <strong>Coordenadas</strong>
        </Typography>
      </Grid>
      <Grid container spacing={2}>
        <Grid item lg={8} md={8} xl={8} xs={12}>
          <TextValidator
            className={classes.textField}
            fullWidth
            InputLabelProps={{
              shrink: true
            }}
            id="endereco"
            label="Endereço"
            disabled={isEditable(obra.ultimoEvento) == false}
            margin="normal"
            onInput={stringUtils.toInputUppercase}
            onChange={(event) => setEndereco(event.target.value)}
            value={endereco}
            variant="outlined"
          />
        </Grid>
        <Grid item lg={2} md={2} xl={2} xs={12}>
          <CustomButton
            variant="outlined"
            onClick={getLatitudeLongitude}
            disabled={isEditable(obra.ultimoEvento) == false || props.obra.isLoading}
            style={{ marginTop: '16px', height: '3.5rem' }}
            startIcon={<SearchIcon />}
            endIcon={props.obra.isLoading && <CircularProgress size={24} />}
          >
            {props.obra.isLoading ? 'Pesquisando...' : 'Pesquisar'}
          </CustomButton>
        </Grid>
        {!modal && props.obra.latitude != null && props.obra.longitude != null &&
          <Grid item lg={2} md={2} xl={2} xs={12}>
            <CustomButton
              variant="outlined"
              disabled={isEditable(obra.ultimoEvento) == false}
              onClick={handleOpenModalPontosAdicionais}
              style={{ marginTop: '16px', height: '3.5rem' }}
              startIcon={<AddLocationAltOutlinedIcon />}
            >
              Incluir pontos adicionais
            </CustomButton>
          </Grid>
        }
      </Grid>
      <Map
        google={props.google}
        style={{ height: "300px", top: '10px', left: 0, right: '24px', borderRadius: "10px" }}
        zoom={15}
        center={{ lat: props.latitude, lng: props.longitude }}
        initialCenter={{ lat: props.latitude, lng: props.longitude }}
      >
        {displayMarkers()}
      </Map>

      {
        (modal ?
          <MapContainerCoordenadasModal toggle={toggle} modal={modal} props={props} obra={props.obra} idObra={props.obra.id} obraCoordenada={obraCoordenada} />
          :
          null
        )
      }
    </>
  );
};

export default GoogleApiWrapper((props) => ({
  apiKey: googleMapsService.getApiKey(),
}))(MapContainer);

